export default {"src":"/_next/static/media/snowmobile.3e8100b4.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};